import { getBrowseLocationId } from "@/modules/anonymousBrowsing/anonymousLocation";
import {
  getPendingCartItems,
  getPendingOffers,
  replayPendingCart,
} from "@/modules/anonymousBrowsing/pendingCart";
import { getOrdersCurrentDetails } from "api/methods";
import { queryClient } from "pages/Root";

import { applyAdvertisedOffers } from "./applyAdvertisedOffers";
import {
  clearReconciliation,
  reconcileAnonymousQuote,
  writeReconciliation,
} from "./cartReconciliation";

const handovers = new Map<string, Promise<void>>();

export const completeAnonymousHandover = (platformId: string): Promise<void> => {
  const pending = handovers.get(platformId);
  if (pending) return pending;

  const handover = replayAnonymousHandover(platformId).finally(() => handovers.delete(platformId));
  handovers.set(platformId, handover);
  return handover;
};

const replayAnonymousHandover = async (platformId: string): Promise<void> => {
  const quote = getPendingCartItems(platformId);
  const claimedOffers = getPendingOffers(platformId);
  if (quote.length === 0 && claimedOffers.length === 0) {
    return;
  }

  const browseLocationId = getBrowseLocationId();

  try {
    const { failed } = await replayPendingCart(platformId);
    if (failed.length > 0) {
      console.warn(`[anonymousBrowsing] ${failed.length} pending cart item(s) could not be added.`);
    }

    await applyAdvertisedOffers(quote, claimedOffers);

    const cart = await queryClient.fetchQuery({
      ...getOrdersCurrentDetails.keyed(),
      staleTime: 0,
    });

    if (cart) {
      writeReconciliation(
        reconcileAnonymousQuote(quote, cart, failed, browseLocationId, claimedOffers),
      );
    } else {
      clearReconciliation();
    }
  } catch (error) {
    // Never fatal to the caller. On the checkout path the verification code is already spent, and on
    // the layout path this runs inside a route loader — in both places the worst outcome allowed is
    // losing the explanation, not the session.
    clearReconciliation();
    console.error("[anonymousCheckout] handover to the new account failed", error);
  }
};
